import { render, staticRenderFns } from "./MessageContainerItem.vue?vue&type=template&id=340f5f0b&"
import script from "./MessageContainerItem.vue?vue&type=script&lang=js&"
export * from "./MessageContainerItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports